var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicenseKeyInuse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#29CC6A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 11.5588C7.75 8.91342 9.92962 6.75 12.6418 6.75C15.354 6.75 17.5336 8.91342 17.5336 11.5588C17.5336 12.2959 17.3654 12.9926 17.0651 13.6155L16.8319 14.099L17.2145 14.4756L24.25 21.4023V23.25H22.8895L22.2575 22.6273V21.0882V20.3382H21.5075H20.1082V18.7059V17.9559H19.3582H17.5164L15.5861 16.054L15.2144 15.6877L14.7418 15.909C14.1096 16.2048 13.3985 16.3676 12.6418 16.3676C9.92962 16.3676 7.75 14.2042 7.75 11.5588ZM12.6418 5.25C9.12222 5.25 6.25 8.06412 6.25 11.5588C6.25 15.0535 9.12222 17.8676 12.6418 17.8676C13.4289 17.8676 14.1863 17.7305 14.8879 17.4719L16.6826 19.2401L16.9015 19.4559H17.209H18.6082V21.0882V21.8382H19.3582H20.7575V22.9412V23.2551L20.9811 23.4754L22.0557 24.5342L22.2747 24.75H22.5821H25H25.75V24V21.0882V20.7741L25.5262 20.5538L18.6314 13.7657C18.8915 13.0782 19.0336 12.3343 19.0336 11.5588C19.0336 8.06412 16.1614 5.25 12.6418 5.25ZM10.75 10.5C10.75 10.0858 11.0858 9.75 11.5 9.75C11.9142 9.75 12.25 10.0858 12.25 10.5C12.25 10.9142 11.9142 11.25 11.5 11.25C11.0858 11.25 10.75 10.9142 10.75 10.5ZM11.5 8.25C10.2574 8.25 9.25 9.25736 9.25 10.5C9.25 11.7426 10.2574 12.75 11.5 12.75C12.7426 12.75 13.75 11.7426 13.75 10.5C13.75 9.25736 12.7426 8.25 11.5 8.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseKeyInuse);
export default __webpack_public_path__ + "static/media/LicenseKeyInuse.eff5e95440fb2fa0fcd46a803d4c628c.svg";
export { ForwardRef as ReactComponent };